import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import AppHeader from '../components/ui/AppHeader';
import MarketingHubSubNav from '../components/marketing/MarketingHubSubNav';
import { useAuth } from '../utils/AuthContext';
import '../components/pm/pm-shared.css';
import './MarketingHubPage.css';

const MarketingHubLayout: React.FC = () => {
  const { user } = useAuth();
  const { pathname } = useLocation();
  const isLander = pathname === '/marketing-hub' || pathname === '/marketing-hub/';

  if (!user) return <Navigate to="/login" replace />;

  return (
    <div className="marketing-hub">
      <AppHeader />
      {!isLander && <MarketingHubSubNav />}
      <Outlet />
    </div>
  );
};

export default MarketingHubLayout;
